export default function RgFooter() {
  return (
    <footer className="border-t border-foreground-100/50 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-10 flex flex-col items-center gap-2 text-center">
        <p className="text-sm text-foreground-500">
          &copy; 2026 《1001旋轉門》出版與研發團隊｜版權所有
        </p>
        <p className="text-xs text-foreground-400">專供嘖嘖專案審查與贊助者閱讀參考</p>
      </div>
    </footer>
  );
}